import request from '../utils/request'
export async function GetNews (para) {
  const data = {
    strCode: 'CMS1001',
    json: JSON.stringify(para)
  }
  return request({
    url: '/ExecWebMethod',
    method: 'post',
    data
  })
}
export async function GetDatas (para) {
  const data = {
    strCode: 'CMS1002',
    json: JSON.stringify(para)
  }
  return request({
    url: '/ExecWebMethod',
    method: 'post',
    data
  })
}
export async function QueryProduct (para) {
  const data = {
    strCode: 'CMS1003',
    json: JSON.stringify(para)
  }
  return request({
    url: '/ExecWebMethod',
    method: 'post',
    data
  })
}
export async function JoinUs () {
  const data = {
    strCode: 'CMS1004',
    json: 'WEB'
  }
  return request({
    url: '/ExecWebMethod',
    method: 'post',
    data
  })
}
export async function CMSQueryCarousel () {
  const data = {
    strCode: 'CMS1005',
    json: 'WEB'
  }
  return request({
    url: '/ExecWebMethod',
    method: 'post',
    data
  })
}

export async function QueryBottom () {
  const data = {
    strCode: 'MANAGE1004',
    json: 'WEB'
  }
  return request({
    url: '/ExecWebMethod',
    method: 'post',
    data
  })
}

export async function QueryGroupNewsCMS (para) {
  const data = {
    strCode: 'WEB2104',
    json: JSON.stringify(para)
  }
  return request({
    url: '/ExecWebMethod',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/News.js